import { render, staticRenderFns } from "./deleteHousekeepingFeeConfig.vue?vue&type=template&id=ecd2b0fe"
import script from "./deleteHousekeepingFeeConfig.vue?vue&type=script&lang=js"
export * from "./deleteHousekeepingFeeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports